﻿module.exports = {
    strategy: 'PercentageNoStake',
    payer: 'Player',
    validation: {
        player: {
            address: {
                required: true
            },
            city: {
                required: true
            },
            firstName: {
                required: true
            },
            lastName: {
                required: true
            },
            taxIdentifier: {
                required: true,
                pattern: '^[0-9]{13}$'
            }
        }
    },
    rules: [
        {
            taxValue: 10.00,
            minApplyAmount: 0.00,
            roundType: 1
        }
    ]
};